import {
  DialogDescription,
  DialogDismiss,
  DialogHeading,
  Form,
  FormSubmit,
} from "@ariakit/react";
import {
  Failure,
  ModalDialog,
  SubmitErrorAlert,
  Success,
  useForm,
} from "@indietabletop/appkit";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { button } from "../common.css.ts";
import {
  useHandleSuccess,
  type SuccessReaction,
} from "../KnightlyOrdersPage/useHandleSuccess.ts";
import * as css from "./style.css.ts";

type ConfirmDialogProps = {
  heading: string;
  description: string;
  submitLabel: string;
  submitTheme?: NonNullable<RecipeVariants<typeof button>>["theme"];
  onSubmit: () => Promise<
    Success<SuccessReaction | undefined> | Failure<string>
  >;
};

export function ConfirmDialog(props: ConfirmDialogProps) {
  const { heading, description, submitLabel, submitTheme, onSubmit } = props;

  const handleSuccess = useHandleSuccess();

  const { form, submitName } = useForm({
    defaultValues: {},
    onSubmit: onSubmit,
    onSuccess(value) {
      handleSuccess(value);
    },
  });

  return (
    <ModalDialog size="small" className={css.dialog}>
      <Form store={form} autoComplete="off" className={css.content}>
        <DialogHeading className={css.heading}>{heading}</DialogHeading>

        <DialogDescription className={css.description}>
          {description}
        </DialogDescription>

        <div className={css.footer}>
          <SubmitErrorAlert name={submitName} className={css.submitError} />

          <div className={css.buttons}>
            <DialogDismiss className={button({ theme: "white" })}>
              Cancel
            </DialogDismiss>

            <FormSubmit className={button({ theme: submitTheme })}>
              {submitLabel}
            </FormSubmit>
          </div>
        </div>
      </Form>
    </ModalDialog>
  );
}
